export default __webpack_public_path__ + "static/media/aboutBg1.c8eb2c5d.png";